var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('MainLayout', {
    class: {
      'monocular-navigation': _vm.isMonocularMode
    },
    attrs: {
      "rightButton": "Next",
      "column": "",
      "step": 1,
      "rightDisabled": _vm.loading
    },
    on: {
      "right": _vm.onNext
    },
    scopedSlots: _vm._u([{
      key: "left",
      fn: function () {
        return [_c('v-btn', {
          attrs: {
            "text": ""
          },
          on: {
            "click": _vm.navigateBack
          }
        }, [_c('v-icon', {
          attrs: {
            "left": ""
          }
        }, [_vm._v("mdi-arrow-left")]), _vm._v(" " + _vm._s(_vm.backLabel) + " ")], 1)];
      },
      proxy: true
    }])
  }, [_c('v-card', {
    staticClass: "d-flex flex-column"
  }, [_c('v-card-text', {
    staticClass: "d-flex flex-column align-center"
  }, [_c('div', {
    staticClass: "d-flex step-1 align-center flex-wrap"
  }, [_c('div', {
    staticClass: "qr-section d-flex flex-column align-center"
  }, [_vm.isMonocularMode ? _c('v-alert', {
    staticClass: "mono-connect-message mb-2",
    attrs: {
      "type": "info",
      "dense": "",
      "outlined": ""
    }
  }, [_vm._v(" Connect only one phone for monocular recording ")]) : _vm._e(), _c('div', {
    staticClass: "image-container qr-container d-flex align-center justify-center my-1 qr-code-wrapper"
  }, [_vm.loading ? _c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "grey",
      "size": "32",
      "width": "5"
    }
  }) : _c('img', {
    staticClass: "w-100 h-100",
    attrs: {
      "src": _vm.session.qrcode
    }
  })], 1)], 1), _c('div', {
    staticClass: "d-flex flex-column flex-grow-1 justify-space-between my-1 instructions-wrapper"
  }, [_c('h1', {
    staticClass: "my-4"
  }, [_vm._v("1. Install or update to "), _c('a', {
    staticClass: "app-store-link",
    attrs: {
      "href": "https://apps.apple.com/us/app/opencap/id1630513242",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("OpenCap app"), _vm.isMonocularMode ? _c('span', [_vm._v(" version 2.1+")]) : _vm._e()]), _vm._v(" from the App Store")]), _c('h1', {
    staticClass: "my-4"
  }, [_vm._v("2. Open the app and scan the QR code")]), _vm.showOpenInAppButton ? _c('div', {
    staticClass: "open-in-app-block my-2"
  }, [_c('p', {
    staticClass: "mb-2"
  }, [_vm._v("On this device? Open in App deeplink also requires app version 2.0+.")]), _c('v-btn', {
    attrs: {
      "color": "grey darken-4",
      "dark": "",
      "block": ""
    },
    on: {
      "click": _vm.openInApp
    }
  }, [_vm._v("Open app with this session (v2.0+)")])], 1) : _vm._e(), _c('h1', {
    staticClass: "my-4"
  }, [_vm._v("3. Mount your phone vertically or horizontally (unlock portrait orientation) on a tripod")]), _vm.isMonocularMode ? _c('h1', {
    staticClass: "my-4"
  }, [_vm._v("4. Position the tripod and camera to capture the volume of interest. Keep the subject within five meters of the camera.")]) : _c('h1', {
    staticClass: "my-4"
  }, [_vm._v("4. Position the tripod and camera to capture the volume of interest")]), !_vm.isMonocularMode ? _c('h1', {
    staticClass: "my-4"
  }, [_vm._v(" 5. Repeat 1-4 for all phones you want to connect ")]) : _vm._e(), _vm.isMonocularMode ? _c('h1', {
    staticClass: "my-4"
  }, [_vm._v(" 5. Have the person practice the activity and verify their whole body is fully in frame and clearly visible to the camera—not cut off, and not hidden behind other objects (e.g. furniture or people) ")]) : _c('h1', {
    staticClass: "my-4"
  }, [_vm._v(" 6. Have the person practice the activity and verify that they are fully in view of at least 2 cameras ")]), _vm.isMonocularMode ? _c('p', {
    staticClass: "my-2"
  }, [_c('a', {
    staticClass: "app-store-link",
    attrs: {
      "href": "https://www.opencap.ai/best-practices?variant=monocular",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v(" Read monocular best practices ")])]) : _vm._e()])])])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }